import React from "react"
import { Container } from "react-bootstrap"
import DefaultLayout from "../../components/layout/DefaultLayout"
import ReviewsTable from "../../components/reviews/ReviewsTable"

const Reviews = () => {
  return (
    <DefaultLayout>
      <Container>
        <ReviewsTable />
      </Container>
    </DefaultLayout>
  )
}

export default Reviews
